import type { JSX } from 'react'

export const BundleCover1 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <rect width='1920' height='1080' fill='#161616' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M964.372 0C898.243 140.15 826.765 300.875 760.043 466.922C678.487 669.889 602.644 884.16 552.963 1080H718.311C765.024 906.178 833.024 714.428 908.506 526.578C985.13 335.889 1068.22 152.217 1141.65 0H964.372Z'
      fill='url(#paint0_linear_628_261)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M230.231 0H36.9951C24.5999 18.5293 12.2554 37.1172 0 55.6875V350.76C69.1899 241.242 147.851 120.279 226.029 6.12891C227.43 4.08398 228.831 2.04102 230.231 0ZM0 1051.95C98.9551 815.973 249.875 509.967 465.771 147.557C496.551 95.8887 522.444 46.5781 544 0H718.339C688.935 72.6758 650.776 149.629 603.229 229.443C400.743 569.342 257.579 856.746 161.891 1080H0V1051.95ZM1794.94 0C1532.84 252.502 1220.99 563.352 946.907 861.629C872.652 942.439 801.416 1015.12 733.617 1080H496.235C595.52 994.102 707.122 886.109 829.093 753.371C1065.24 496.377 1328.75 230.537 1565.07 0H1794.94Z'
      fill='url(#paint1_linear_628_261)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_628_261'
        x1='847.304'
        y1='0'
        x2='847.304'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#1E0A36' />
        <stop offset='1' stopColor='#380B1F' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_261'
        x1='897.47'
        y1='0'
        x2='897.47'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2B0D4F' />
        <stop offset='1' stopColor='#4B0D29' />
      </linearGradient>
    </defs>
  </svg>
)
